import { useRichiestaServer } from '@lucan/base-ui'
import { OPERAZIONI } from 'configuration/ConfigurazioneApi'
import { ASSETS } from 'configuration/ConfigurazioneRotte'
import { CHIAVI_SESSIONE } from 'configuration/ConfigurazioneSessione'
import { useSessione } from 'context/SessioneProvider'
import { useAppContext } from 'GlobalContext'

export default function BottoneCIE() {
  const { uri } = useAppContext()
  const { salvaInSessione } = useSessione()
  const {
    ScatolaMessaggi,
    inviaOperazione,
    inAttesaDelServer
  } = useRichiestaServer()

  async function avviaCie() {
    const { ok, data } = await inviaOperazione(OPERAZIONI.SPID_AVVIO_CIE, null, {}, {
      headers: { uri, backUrlOrigin: window.location.origin }
    })

    if (ok) {
      const { esito, sso_request, uuidRoom } = data
      if (esito) {
        if (uuidRoom) salvaInSessione(CHIAVI_SESSIONE.CHIAVE_UUID_ROOM, uuidRoom)
        window.location.href = sso_request
      }
    }
  }

  return (
    <>
      <button
        disabled={inAttesaDelServer}
        style={{ all: 'unset', cursor: 'pointer' }}
      >
        <img
          src={`${ASSETS}entra_con_cie.svg`}
          onClick={avviaCie}
          width={240}
          alt='entra_con_cie'
        />
      </button>

      {ScatolaMessaggi}
    </>
  )
}